import { Controller } from "@hotwired/stimulus"

// 「全て」チェックボックスと個別チェックボックスの排他制御を data-group で汎用化
export default class extends Controller {
  static targets = ['input']

  toggle({ target }) {
    const { group, facultyId } = target.dataset

    let inputs = this.inputTargets.filter(e => e.dataset.group === group)
    if (facultyId) inputs = inputs.filter(e => e.dataset.facultyId === facultyId)

    const allInput = inputs.find(e => e.dataset.isAll)
    const others   = inputs.filter(e => !e.dataset.isAll)

    if (target === allInput) {
      allInput.checked = true
      others.forEach(e => e.checked = false)
    } else {
      allInput.checked = others.every(e => !e.checked)
    }
  }
}
